<template lang="pug">
  .table-responsive
    table#ConsSalida.table.is-striped.is-fullwidth
      thead
        tr
          th #
          th Consumible
          th Descripción
          th Cantidad Salida
        tr(v-for="(i, index) in consumibles")
          td
            | {{ index + 1}}
            | &nbsp
            a.button.is-danger.is-small.is-rounded(@click="eliminarItem(i)")
              i.fas.fa-trash-alt
          td(v-if="i.subcategoria")
            .control
              .tags.has-addons
                span.tag.is-black
                  i.fas.fa-tag
                  | &nbsp {{ i.categoria}}
                span.tag.is-warning {{ i.subcategoria}}
          td(v-else) 
            span.tag.is-black {{ i.categoria}}
          td(v-html="getDescripcion(i)")
          td {{ i.cantidad_Exit }}
      tbody
</template>

<script>
  export default {
    name: 'ListCons_Salida',
    props: {
      consumibles: {
        type: Array,
        default: []
      },
    },
    methods: {
      eliminarItem(item) {
        this.$emit('deleteCons', item)
      },
      getDescripcion(data) {
        let marca = `${data.marca} | `
        let modelo = `${data.modelo}`
        return `${marca}${modelo}`
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/ListCons_Salida.vue